document.addEventListener('turbolinks:load', function() {
	 getHeaderFooter();
});

// style - toto.css
// js - toto.js

	async function getHeaderFooter() {
		try {
			const response = await fetch('https://totousa.com/kbis_template.php'); 
			
      if (!response.ok) {
				throw new Error('Unable to fetch header')
			};

			const data = await response.json();

      $('#toto-header').html(data.header);
      $('#toto-footer').html(data.footer)

		} catch (error) {
			console.error('Fetch error:', error)
		}

	}



